import { httpClient } from "@coworker/http-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export async function updateTaskById(data: object, taskId: string) {
  return await httpClient.tasks.put(`/v1/task/${taskId}/update`, {
    body: data,
  });
}

export function useUpdateTaskMutation(
  ignoreInvalidateByTaskId?: boolean,
  taskId?: string
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["updateTask", taskId],
    mutationFn: (data: { data: object; taskId: string }) => {
      return updateTaskById(data.data, data.taskId);
    },
    onSuccess: async (data: any) => {
      if (data) {
        const taskId = data?.id;
        if (!ignoreInvalidateByTaskId) {
          await queryClient.invalidateQueries({
            queryKey: ["task", "id", taskId, data.task_type],
          });
        }
        queryClient.invalidateQueries({
          queryKey: ["task", "activities", taskId],
        });
      }
    },
    onError: (error) => {
      console.log("Error while updating task", error);
    },
  });
}
